export enum AddressTypeEnum {
  personal = 'personal',
  company = 'company',
  parentCompany = 'parent-company',
}
